import { NotificationManager } from 'react-notifications'

class UploadExceptionList {
  constructor(file, videos){
    this.exceptions = [
      {
        name: 'maxVideos',
        condition: () => videos.length > 4,
        message: 'Przekroczono maksymalną liczbę filmików',
        description: 'Maksymalna liczba filmików: 5'
      },
      {
        name: 'videoName',  
        condition: () => [...videos].map(({file: {name}}) => name).includes(file.name),
        message: 'Filmik o takiej nazwie już istnieje',
        description: 'Nazwa pliku musi być unikalna'
      },
      {
        name: 'videoSize',
        condition: () => file.size > 100 * 1024 * 1024,
        message: 'Maksymalny rozmiar pliku przekracza 100MB',
        description: 'Maksymalny rozmiar pliku: 100MB'
      },
      {
        name: 'videoSumSize',
        condition: () => videos.reduce((acc, video) => acc + video.file.size, 0) > 500 * 1024 * 1024,
        message: 'Suma rozmiarów filmików przekracza 500MB',
        description: 'Suma rozmiarów filmików do 500MB'
      },
      {
        name: 'videoFormat',
        condition: () => !['video/mp4', 'video/mov', "mp4", "mov"].includes(file.type),
        message: 'Nieprawidłowy format pliku',
        description: 'Dostępne formaty: mp4, mov'
      }  
    ]
  } 
  checkExceptions() {
    this.exceptions.forEach(({condition, message, name}) => {
      if (condition()) {
        NotificationManager.error(message);
        throw new Error(`${name}: ${message}`);
      }
    });
  }
  uploadExceptionsDescription() {
    return this.exceptions.map(({description}) => description).join('; ')
  }
}



export default UploadExceptionList;
